import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'store';

import { types } from './types';
import { login, logout, ssoCallback } from './thunks';

const authStore = (store: RootState) => store?.auth;

const selectIsLoggedIn = createSelector(
  [authStore],
  (store) => store?.isLoggedIn ?? false
);

const selectAuthUser = createSelector([authStore], (store) => store?.user);

const selectIsGuestUser = createSelector(
  [authStore],
  (store) => store?.isGuestUser
);

const selectAuthUserRole = createSelector(
  [authStore],
  (store) => store?.user?.role
);

export {
  login,
  types,
  logout,
  ssoCallback,
  selectAuthUser,
  selectIsLoggedIn,
  selectIsGuestUser,
  selectAuthUserRole,
};
